export default __webpack_public_path__ + "static/media/534B3FEC-EF30-40BB-B80C-5EE66C279E77_1_105_c.f7c16607.jpeg";